import { Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable, filter, map } from 'rxjs';
import { Printer } from 'src/app/models';
import { AppSelectors } from 'src/app/store/app/app.selectors';

@Pipe({
  name: 'printerById'
})
export class PrinterByIdPipe implements PipeTransform {
  constructor(private readonly store: Store) {}

  transform(printerId: number): Observable<Printer> {
    return this.store.select(AppSelectors.printers).pipe(
      filter((printers) => !!printers?.length),
      map((printers) => printers.find((i) => i.id === printerId))
    );
  }
}
